import Bundles from "./module/bundles";
import Storage from "./localStorage";
import Notify from "./module/notify";
import Cart from "./module/shoppingCart";

const wp = wp_metis;
const storage = new Storage();
const bundles = new Bundles();
const cart = new Cart();
const notify = new Notify();

const alpineData = () => {
  return {
    bundleId: null,
    bundleConfiguration: null,
    bundleConfigurationHasChanged: false,
    sections: [],
    shoppingCart: null,

    init: async function () {
      this.bundleId = JSON.parse(document.querySelector("[data-bundle]").dataset.bundle).bundleId;
      this.bundleConfiguration = storage.getBundleData(this.bundleId);

      const htmlSections = [...document.querySelectorAll("[data-section]")];
      htmlSections.forEach((htmlSection) => {
        const courses = [];
        const data = JSON.parse(htmlSection.dataset.section);
        const htmlCourses = [...htmlSection.querySelectorAll("[data-bundle-course]")];

        htmlCourses.forEach((htmlCourse) => {
          courses.push(JSON.parse(htmlCourse.dataset.bundleCourse));
        });

        this.sections.push({
          ...data,
          courses,
          selectedCourses: [],
        });
      });

      const coursesFromConfiguration = this.getCoursesFromBundleConfigurationFormatted();
      this.sections.forEach((section, sectionIndex) => {
        this.sections[sectionIndex].selectedCourses = coursesFromConfiguration.filter(course => course.sectionId === section.id);
      });

      const localKeyExist = storage.getWarenkorbKey();
      if (localKeyExist) {
        const warenkorb = await cart.getShoppingCart(localKeyExist);
        this.shoppingCart = warenkorb;
      }

      document.addEventListener('updated-shoppingCart', async (event) => {
        console.log(event.detail.cart);
        this.shoppingCart = event.detail.cart;
      });
    },

    onCourseButtonClick: async function (courseNumber, sectionId) {
      const section = this.sections.find((section) => section.id === sectionId);
      const newCourse = section.courses.find((course) => course.courseNumber === courseNumber);

      if(section.selectedCourses.includes(newCourse)) {
        section.selectedCourses = section.selectedCourses.filter((course) => course !== newCourse);

      } else {
        const totalCredits = this.getCurrentTotalCreditsInSections(section);
        if(totalCredits + newCourse.credits > section.creditsMax) {
          notify.emit([{message: "Dieser Kurs überschreitet die maximale Anzahl an Credits für diese Kategorie."}]);
          return;
        }

        section.selectedCourses.push(newCourse);
      }
      this.bundleConfigurationHasChanged = true;
    },

    isSelectedCourse: function (courseNumber, sectionId) {
      const section = this.sections.find((section) => section.id === sectionId);
      return section.selectedCourses.find(course => course.courseNumber === courseNumber);
    },

    disabledCourse: function (courseNumber, creditsForCourse, productId, sectionId) {
      const isSelected = this.isSelectedCourse(courseNumber, sectionId);
      const section = this.sections.find((section) => section.id === sectionId);
      const totalCredits = this.getCurrentTotalCreditsInSections(section);
      const foundCourseInSameProduct = section.selectedCourses.find(course => course.productId === productId);
      return !isSelected && (foundCourseInSameProduct || totalCredits + creditsForCourse > section.creditsMax);
    },

    getPercentageOfSection: function (sectionId) {
      const section = this.sections.find((section) => section.id === sectionId);
      const totalCredits = this.getCurrentTotalCreditsInSections(section);
      return (totalCredits / section.creditsMax) * 100;
    },

    configurationIsValid: function () {
      return this.sections.every((section) => {
        const totalCredits = this.getCurrentTotalCreditsInSections(section);
        return totalCredits >= section.creditsMin && totalCredits <= section.creditsMax;
      });
    },

    canAddConfigurationToCart: function () {
      return this.configurationIsValid();
    },

    getPrice: function () {
      return this.formatPrice(this.sections.reduce((acc, section) => acc + section.selectedCourses.reduce((accInner, course) => accInner + course.price, 0), 0));
    },

    getCurrentTotalCreditsInSections: function (section) {
      return section.selectedCourses.reduce((acc, course) => acc + course.credits, 0);
    },

    formatPrice: function (price) {
      if (price != undefined || price != null) {
        return price.toLocaleString('de-DE', {maximumFractionDigits:2, minimumFractionDigits:2})
      }
      return ''
    },

    createOrUpdateBundleConfigurationAndSignalAddToCart: async function () {
      if(!this.configurationIsValid()) {
        return;
      }

      if(this.cartAlreadyHasConfiguration() && this.bundleConfigurationHasChanged) {
        this.bundleConfiguration = null; // create new config
      }

      let coursesToAdd = [];
      let coursesToDelete = [];

      const currentlySelectedCourses = this.sections.reduce((acc, section) => acc.concat(section.selectedCourses), []);

      if(this.bundleConfiguration) {
        const currentCoursesInConfiguration = this.getCoursesFromBundleConfigurationFormatted();

        coursesToAdd = currentlySelectedCourses.filter(course => !currentCoursesInConfiguration.includes(course));
        coursesToDelete = currentCoursesInConfiguration.filter(course => !currentlySelectedCourses.includes(course));

      } else {
        coursesToAdd = currentlySelectedCourses
      }

      for (const course of Object.values(coursesToAdd)) {
        if(this.bundleConfiguration) {
          this.bundleConfiguration = await bundles.addKursToBundlekonfiguration(this.bundleConfiguration.bundleKonfigurationKey, course.sectionId, course.courseNumber);
        } else {
          this.bundleConfiguration = await bundles.addBundleKursAndCreateBundlekonfiguration(this.bundleId, course.sectionId, course.courseNumber);
        }
      };

      for (const course of Object.values(coursesToDelete)) {
        this.bundleConfiguration = await bundles.deleteBundleKurs(this.bundleConfiguration.bundleKonfigurationKey, course.sectionId,  course.courseNumber);
      };

      const isBundlekonfigurationValide = await bundles.isBundlekonfigurationValide(this.bundleConfiguration.bundleKonfigurationKey);
      storage.setBundleData(this.bundleId, JSON.parse(JSON.stringify(this.bundleConfiguration)));

      if(isBundlekonfigurationValide) {
        document.dispatchEvent(new CustomEvent('add-bundle-config-to-cart', {detail: {bundleConfiguration: this.bundleConfiguration}}));
        this.bundleConfigurationHasChanged = false;
      }
    },

    getCoursesFromBundleConfigurationFormatted: function () {
      let courses = [];

      if(this.bundleConfiguration) {
        this.bundleConfiguration.bundleKonfigurationUnterkategorien.forEach(section => {
          const sectionId = section.bundleUnterkategorie.id;
          const sectionLocal = this.sections.find(section => section.id === sectionId);
          courses = [...courses, ...section.bundleKonfigurationKurse.map(configuredCourse => sectionLocal.courses.find(course => course.courseNumber === configuredCourse.kurs.kursnr))];
        });
      }

      return courses;
    },

    cartAlreadyHasConfiguration: function() {
      if(this.shoppingCart) {
        const bundlesInCart = this.shoppingCart.bundles;
        const bundleConfigurationKey = this.bundleConfiguration?.bundleKonfigurationKey ?? null;
        if(bundlesInCart && bundleConfigurationKey) {
          return bundlesInCart.some(bundle => bundle.bundleKonfiguration.bundleKonfigurationKey === bundleConfigurationKey);
        }
      }
      return false;
    }
  };
};

if(!window.alpineData) {
  window.alpineData = {};
}
window.alpineData.appProductBundles = alpineData;
